import React, { useState, useEffect } from "react";

import Viewer from './viewer'

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

import WeekDate from './components/WeekDate'
import Header from './components/Header'
import TemplateHeader from './components/TemplateHeader'
import Footer from './components/Footer'
import FooterAcc from './components/FooterAcc'
import FooterMin from './components/FooterMin'
import FooterAccMin from './components/FooterAccMin'
import Divider from './components/Divider'
import DualEventRow from './components/DualEventRow'
import SingleEventRow from './components/SingleEventRow'
import CentredImage from './components/CentredImage'
import QuoteBox from './components/QuoteBox'
import FreeText from './components/FreeText'
import EventsDbPanel from './components/EventsDbPanel'

// Preheader: hidden preview text shown next to the subject line in the inbox. Kept outside
// the layout table (matches what most clients look at when picking preview text).
function getEmailStart(preheaderText) {
	return `<!DOCTYPE html>

<html lang="en-GB" xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:v="urn:schemas-microsoft-com:vml">
<head>
<title></title>
<meta content="text/html; charset=utf-8" http-equiv="Content-Type"/>
<meta content="width=device-width, initial-scale=1.0" name="viewport"/>
<style>
		* {
			box-sizing: border-box;
		}

		body {
			margin: 0;
			padding: 0;
		}

		a[x-apple-data-detectors] {
			color: inherit !important;
			text-decoration: inherit !important;
		}

		#MessageViewBody a {
			color: inherit;
			text-decoration: none;
		}

		p {
			line-height: inherit
		}

		.ql-align-center {
			text-align: center !important;
		}

		.ql-align-right {
			text-align: right !important;
		}

		.ql-align-justify {
			text-align: justify !important;
		}

		.desktop_hide,
		.desktop_hide table {
			mso-hide: all;
			display: none;
			max-height: 0px;
			overflow: hidden;
		}

		@media (min-width:620px) {
			h1 {
				font-size: 36px !important;
			}
		}

		@media (max-width:620px) {
			.desktop_hide table.icons-inner {
				display: inline-block !important;
			}

			.icons-inner {
				text-align: center;
			}

			.icons-inner td {
				margin: 0 auto;
			}

			.row-content {
				width: 100% !important;
			}

			.mobile_hide {
				display: none;
			}

			.stack .column {
				width: 100%;
				display: block;
			}

			.mobile_hide {
				min-height: 0;
				max-height: 0;
				max-width: 0;
				overflow: hidden;
				font-size: 0px;
			}

			.desktop_hide,
			.desktop_hide table {
				display: table !important;
				max-height: none !important;
			}

            .header-row .column-2 .block-3.heading_block h2 {
				font-size: 16px !important;
			}

			h1 {
				font-size: 36px !important;
			}

			.header-row .column-2 .block-2.heading_block td {
				padding-top: 30px !important;
				padding-left: 20px;
				padding-right: 20px;
			}

			.mobile_shorten {
				width: 5% !important;
				height: 80px !important;
			}
		}
		@media (max-width:499px) {
			h1 {
				font-size: 28px !important;
			}
		}

		@media (max-width:432px) {
			.header-row .column-2 .block-2.heading_block td {
				padding-top: 20px !important;
			}
		}

		@media (max-width:368px) {
			.header-row .column-2 .block-2.heading_block td {
				padding-top: 15px !important;
				padding-left: 0px !important;
				padding-right: 0px !important;
			}

			h1 {
				font-size: 24px !important;
			}
		}

		@media (max-width:280px) {
			h1 {
				font-size: 20px !important;
			}
		}
	</style>
</head>
<body style="background-color: #FFFFFF; margin: 0; padding: 0; -webkit-text-size-adjust: none; text-size-adjust: none;">
${preheaderText ? `<div style="display:none;font-size:1px;color:#fff;line-height:1px;max-height:0;max-width:0;opacity:0;overflow:hidden;mso-hide:all;">${preheaderText}&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp; &zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;</div>` : ""}
    <table border="0" cellpadding="0" cellspacing="0" class="nl-container" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; background-color: #FFFFFF;"  width="100%">
        <tbody>
            <tr>
                <td>`
}

// Code for background image, taken out because doesn't like dark mode.  Goes in style of table tag above "background-image: url('https://business-butler-media.s3.eu-west-2.amazonaws.com/email-images/background.png'); background-position: top 20px center; background-size: auto; background-repeat: repeat-y;"

const emailend = `</td>
</tr>
</tbody>
</table><!-- End -->
</body>
</html>`

// Titles shown in each component's toolbar. Components that render their own <h4> title
// (event rows, QuoteBox, CentredImage) are left out so the title isn't duplicated.
const componentTitles = {
	WeekDate: "Week Date",
	Header: "Header",
	TemplateHeader: "Template Header",
	Divider: "Divider",
	FreeText: "Free Text",
	FreeTextEvents: "Free Text",
	Footer: "Footer",
	FooterAcc: "Footer (Acc)",
	FooterMin: "Footer (Min)",
	FooterAccMin: "Footer (Min, Acc)",
}

let componentArray = [{id:0, component:"", html: getEmailStart("")},{id:1, component:"", html: emailend}]
let nextComponentId = 100;

const defaultFreeTextEvents = '<p><strong style="color: rgb(230, 0, 0);">Dear Members,</strong><strong style="color: black;"></strong></p><p><strong style="color: rgb(230, 0, 0);">15 EVENTS</strong><strong style="color: black;"> </strong><span style="color: black;">this week, 3 from Find A Business Expert and 12 from our collaboration partners.</span></p><p><span style="color: black;">Details and registrations via your </span><a href="https://member-dashboard.findabusinessexpert.com/events" rel="noopener noreferrer" style="color: rgb(0, 102, 204);" target="_blank">member portal</a>.</p><p><strong style="color: black;"><u>Earn Credits for attending FaBE events</u></strong></p><ul><li>Earn 5 credits for every FaBE event you attend.</li><li>Attend 5 events in a calendar month to receive 10 bonus credits.</li><li>Collect 100 credits and enjoy a month of free membership.</li><li><span style="color: black;">Redeem your credits for selected expert services—keep an eye out for exclusive member offers.</span></li></ul>'

const Main = (props) => {

    const [html, setHtml] = useState("")
    const [componentToAdd, setComponentToAdd] = useState("DualEventRow")
    const [preheaderText, setPreheaderText] = useState("")

    useEffect(() => {
        setHtml(componentArray.map(item => {return (item.html)}).join(""))
    }, [])

    useEffect(() => {
        updateComponentHTML(0, getEmailStart(preheaderText))
    }, [preheaderText])

    function updateComponentHTML(id, newhtml){

        componentArray.forEach(item => {
            if(item.id === id){
                item.html = newhtml;
                setHtml(componentArray.map(item => {return (item.html)}).join(""))
            }
        })
    }

    function addComponent(){
        const component = {
            id: nextComponentId,
            component: componentToAdd,
            html: " "  //New component doesn't appear unless string is not empty, not sure why, hence the space
        }
        componentArray.splice(componentArray.length - 2,0,component)
        nextComponentId +=1
        setHtml(componentArray.map(item => {return (item.html)}).join(""))
    }

    // ids 0 and 1 are the fixed email start/end wrappers; they can't be removed or moved
    function removeComponent(id){
        if(id === 0 || id === 1) return
        componentArray = componentArray.filter(item => item.id !== id)
        setHtml(componentArray.map(item => {return (item.html)}).join(""))
    }

    function moveComponent(id, direction){
        const index = componentArray.findIndex(item => item.id === id)
        const target = index + direction
        if(index < 1 || target < 1 || target > componentArray.length - 2) return
        const reordered = [...componentArray]
        ;[reordered[index], reordered[target]] = [reordered[target], reordered[index]]
        componentArray = reordered
        setHtml(componentArray.map(item => {return (item.html)}).join(""))
    }

	function setToEventsEmail() {
		componentArray = [
			{id:0, component:"", html: getEmailStart(preheaderText)},
			{id:nextComponentId++, component:"WeekDate", html: " "},
			{id:nextComponentId++, component:"Header", html: " "},
			{id:nextComponentId++, component:"Divider", html: " "},
			{id:nextComponentId++, component:"QuoteBox", html: " "},
			{id:nextComponentId++, component:"FreeTextEvents", html: " "},
			{id:nextComponentId++, component:"Footer", html: " "},
			{id:1, component:"", html: emailend}];

		setHtml(componentArray.map(item => {return (item.html)}).join(""))
	}

	function setToStandardEmail() {
		componentArray = [{id:0, component:"", html: getEmailStart(preheaderText)},{id:nextComponentId++, component:"Divider", html: " "},{id:nextComponentId++, component:"TemplateHeader", html: " "},{id:nextComponentId++, component:"Divider", html: " "},{id:nextComponentId++, component:"FreeText", html: " "},{id:nextComponentId++, component:"FooterMin", html: " "},{id:1, component:"", html: emailend}];

		setHtml(componentArray.map(item => {return (item.html)}).join(""))
	}

	function setToStandardAccEmail() {
		componentArray = [{id:0, component:"", html: getEmailStart(preheaderText)},{id:nextComponentId++, component:"Divider", html: " "},{id:nextComponentId++, component:"TemplateHeader", html: " "},{id:nextComponentId++, component:"Divider", html: " "},{id:nextComponentId++, component:"FreeText", html: " "},{id:nextComponentId++, component:"FooterAccMin", html: " "},{id:1, component:"", html: emailend}];

		setHtml(componentArray.map(item => {return (item.html)}).join(""))
	}

	// weekGroups: ordered array of {rows: [{kind:'dual'|'single', a, b}], eventCount, dateRangeText}
	function generateEventsFromDb(weekGroups, weekText) {
		const totalEventCount = weekGroups.reduce((sum, group) => sum + group.eventCount, 0)
		const preheader = preheaderText || `${totalEventCount} event${totalEventCount === 1 ? "" : "s"} this week from Find A Business Expert.`
		setPreheaderText(preheader)

		const firstGroupCount = weekGroups[0]?.eventCount || 0
		const introHtml = `<p><strong style="color: rgb(230, 0, 0);">Dear Members,</strong></p><p><strong style="color: rgb(230, 0, 0);">${firstGroupCount} EVENT${firstGroupCount === 1 ? "" : "S"}</strong><span style="color: black;"> this week from Find A Business Expert.</span></p><p><span style="color: black;">Details and registrations via your </span><a href="https://member-dashboard.findabusinessexpert.com/events" rel="noopener noreferrer" style="color: rgb(0, 102, 204);" target="_blank">member portal</a>.</p>`
		const outroHtml = `<p>Have a productive week!</p><p>FaBE Team</p>`

		const newComponents = [
			{id:0, component:"", html: getEmailStart(preheader)},
			{id:nextComponentId++, component:"WeekDate", html: " ", extraProps:{initialText: weekText}},
			{id:nextComponentId++, component:"Header", html: " "},
			{id:nextComponentId++, component:"Divider", html: " "},
			{id:nextComponentId++, component:"QuoteBox", html: " "},
			{id:nextComponentId++, component:"FreeTextEvents", html: " ", extraProps:{freeText: introHtml}},
		]

		weekGroups.forEach((group, index) => {
			if(index > 0){
				const middleHtml = `<p class="ql-align-center" style="text-align: center;"><u>You can also look forward to the following <strong style="color: rgb(230, 0, 0);">${group.eventCount} EVENT${group.eventCount === 1 ? "" : "S"}</strong> from the <strong>${group.dateRangeText}</strong>:</u></p>`
				newComponents.push({id:nextComponentId++, component:"FreeTextEvents", html: " ", extraProps:{freeText: middleHtml}})
			}
			group.rows.forEach(row => {
				if(row.kind === "dual"){
					newComponents.push({id:nextComponentId++, component:"DualEventRow", html: " ", extraProps:{prefill1: row.a, prefill2: row.b}})
				} else {
					newComponents.push({id:nextComponentId++, component:"SingleEventRow", html: " ", extraProps:{prefill1: row.a}})
				}
			})
		})

		newComponents.push({id:nextComponentId++, component:"FreeTextEvents", html: " ", extraProps:{freeText: outroHtml}})
		newComponents.push({id:nextComponentId++, component:"FooterMin", html: " "})
		newComponents.push({id:1, component:"", html: emailend})

		componentArray = newComponents
		setHtml(componentArray.map(item => {return (item.html)}).join(""))
	}

    return (<>
        <Container>
            <Row>
                <Col md={12}>
                    <EventsDbPanel onGenerate={generateEventsFromDb} />
                </Col>
            </Row>
            <Row>
                <Col md={5}>
                    <Form.Group controlId="exampleForm.ControlSelect1">
						<Row>
					<Button onClick={setToEventsEmail}>Events</Button>
					<Button onClick={setToStandardEmail}>Standard (EC)</Button>
					<Button onClick={setToStandardAccEmail}>Standard (Acc)</Button>
						</Row>
						<Form.Label>Preheader (inbox preview text)</Form.Label>
						<Form.Control onChange={(event) => setPreheaderText(event.target.value)} value={preheaderText} placeholder="Shown next to the subject line in the inbox" />
                        <Form.Label>Add Component</Form.Label>
                        <Form.Control onChange={(event) => setComponentToAdd(event.target.value)} as="select" value={componentToAdd}>
                            <option value="DualEventRow">Dual Event Row</option>
							<option value="SingleEventRow">Single Event Row</option>
							<option value="QuoteBox">QuoteBox</option>
                            <option value="FreeText">Free Text</option>
							<option value="CentredImage">Image</option>
							<option value="FooterMin">Footer (Min, campaigns)</option>
							<option value="FooterAccMin">Footer (Min, Acc)</option>
                        </Form.Control>
                    </Form.Group>
                    <Button onClick={addComponent}>Add</Button>
                    <Container>
                        {componentArray.map((item, index) => { return (
                            <Row key={item.id}>
                                <Col>
                                    {item.component !== "" && <div className="d-flex justify-content-between align-items-center mb-1">
                                        <h5 className="mb-0">{componentTitles[item.component]}</h5>
                                        <div>
                                        <Button size="sm" variant="outline-secondary" className="mr-1" disabled={index === 1} onClick={() => moveComponent(item.id, -1)} title="Move up">↑</Button>
                                        <Button size="sm" variant="outline-secondary" className="mr-1" disabled={index === componentArray.length - 2} onClick={() => moveComponent(item.id, 1)} title="Move down">↓</Button>
                                        <Button size="sm" variant="outline-danger" onClick={() => removeComponent(item.id)} title="Remove component">Remove</Button>
                                        </div>
                                    </div>}
                                    {item.component === "WeekDate" && <WeekDate updateComponentHTML={updateComponentHTML} key={item.id} id={item.id} initialText={item.extraProps?.initialText}/>}
                                    {item.component === "Header" && <Header updateComponentHTML={updateComponentHTML} key={item.id} id={item.id}/>}
									{item.component === "TemplateHeader" && <TemplateHeader updateComponentHTML={updateComponentHTML} key={item.id} id={item.id}/>}
                                    {item.component === "Footer" && <Footer updateComponentHTML={updateComponentHTML} key={item.id} id={item.id}/>}
									{item.component === "FooterAcc" && <FooterAcc updateComponentHTML={updateComponentHTML} key={item.id} id={item.id}/>}
									{item.component === "FooterMin" && <FooterMin updateComponentHTML={updateComponentHTML} key={item.id} id={item.id}/>}
									{item.component === "FooterAccMin" && <FooterAccMin updateComponentHTML={updateComponentHTML} key={item.id} id={item.id}/>}
                                    {item.component === "Divider" && <Divider updateComponentHTML={updateComponentHTML} key={item.id} id={item.id}/>}
                                    {item.component === "DualEventRow" && <DualEventRow updateComponentHTML={updateComponentHTML} key={item.id} id={item.id} prefill1={item.extraProps?.prefill1} prefill2={item.extraProps?.prefill2}/>}
                                    {item.component === "SingleEventRow" && <SingleEventRow updateComponentHTML={updateComponentHTML} key={item.id} id={item.id} prefill1={item.extraProps?.prefill1}/>}
									{item.component === "CentredImage" && <CentredImage updateComponentHTML={updateComponentHTML} key={item.id} id={item.id}/>}
									{item.component === "QuoteBox" && <QuoteBox updateComponentHTML={updateComponentHTML} key={item.id} id={item.id}/>}
									{item.component === "FreeText" && <FreeText updateComponentHTML={updateComponentHTML} key={item.id} id={item.id}/>}
									{item.component === "FreeTextEvents" && <FreeText updateComponentHTML={updateComponentHTML} key={item.id} id={item.id} freeText={item.extraProps?.freeText ?? defaultFreeTextEvents}/>}
                                </Col>
                            </Row>
                            )}
                        )}
                    </Container>
                </Col>
                <Col md={7}>
                    <Viewer html={html} />
                </Col>
            </Row>
        </Container>

    </>)

};

export default Main;